import { AxiosResponse } from 'axios';
import { ConfigAxiosInstance } from './ConfigAxiosInstance';
import { IConfigFrontendInDTO } from './model/input/IConfigFrontendInDTO';

export function fetchConfiguration(): Promise<AxiosResponse<IConfigFrontendInDTO>> {
  return ConfigAxiosInstance.get('/api/v1/backendInfo');
}
